import { PaymentEndpoint } from "@/views/loyalty/shared/endpoint_services/payment-endpoint-service"
import { SearchStuffModel } from "@/views/loyalty/models/search_stuff.model"

export class PaymentService {
    constructor () {
        this.paymentEndpoint = new PaymentEndpoint()
    }

    async getPayment (item) {
        return this.paymentEndpoint.get_payment(item)
    }

    async getPayments (page, limit, filter, search) {
        return this.paymentEndpoint.get_payments(page, limit, filter, search || SearchStuffModel)
    }
}
